export default __webpack_public_path__ + "static/sampleimage3-1a5920b7908c8a212c415024189a3276.svg";